// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import serversChildren from '../../../../vue/routes/admin/servers';
import { useUserStore } from '@/vue/stores/user';
import type { AdminRouteItem } from '../../../types/Admin/AdminRouteItem';

export default (): AdminRouteItem[] => {
    const userStore = useUserStore();

    return serversChildren
        .filter((route) => route.meta.permissions()
            .some((permission: string) => userStore.hasPermission(permission))) as AdminRouteItem[];
};
